export const handleListViewMenuChangeMove = (e = [], setListViewMenuDatta) => {
  const tempData = e.filter((item) => item?.key).map((item) => item.key);

  setListViewMenuDatta(tempData);
};
